import { useMutation } from 'react-query'
import { croneJobsService } from 'src/services/crone-jobs.service'

export const useApproveAllConsumerScans = () => {
  return useMutation(
    (challange: string | null) => croneJobsService.approveAllConsumerScans(challange),
    {},
  )
}
